<script setup lang="ts">
import { MEDIA_CDN_URL, VIDEO } from '@/constants/media';

useState('withVideoBg', () => false);

const isWithBg = useState('withVideoBg');
</script>

<template>
  <video
    v-if="isWithBg"
    class="bg-video"
    muted
    autoplay
    loop
    playsinline
    preload="none"
    poster="/bg_static.svg"
  >
    <source
      :src="MEDIA_CDN_URL + VIDEO.get('bg_4k')"
      type="video/webm"
      media="screen AND (min-width: 1600px)"
    />

    <source
      :src="MEDIA_CDN_URL + VIDEO.get('bg_fhd')"
      type="video/webm"
      media="screen AND (min-width: 1260px)"
    />
    <source
      :src="MEDIA_CDN_URL + VIDEO.get('bg_mobile')"
      type="video/webm"
      media="screen"
    />
  </video>
  <div :class="isWithBg ? 'tint' : 'bg-static'"/>
</template>

<style scoped lang="postcss">
.bg-video,
.tint,
.bg-static {
  width: 100dvw;
  height: 100dvh;
  object-fit: cover;
  position: fixed;
  inset: 0;
  z-index: -1;
}

.tint {
  background: rgb(2 9 24 / 16%);
}

.bg-static {
  background: url('/bg_static.svg') no-repeat center / cover;
}
</style>
